'use client'

import { ReactNode } from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible'
import { ChevronDown } from 'lucide-react'

export interface IntegrationCardLayoutProps {
  title: string
  description?: string
  icon?: ReactNode
  headerAction?: ReactNode
  children: ReactNode
  /** Whether to start expanded. Defaults to false (collapsed). */
  defaultOpen?: boolean
}

export function IntegrationCardLayout({
  title,
  description,
  icon,
  headerAction,
  children,
  defaultOpen = false,
}: IntegrationCardLayoutProps) {
  return (
    <Collapsible defaultOpen={defaultOpen}>
      <Card>
        <CardHeader className="hover:bg-muted/50 transition-colors">
          <div className="flex items-center justify-between gap-3 w-full">
            <CollapsibleTrigger className="flex min-w-0 flex-1 cursor-pointer items-center justify-between gap-3 rounded-sm text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
              <div className="flex min-w-0 items-start gap-3">
                {icon && <span className="mt-0.5 shrink-0 text-muted-foreground">{icon}</span>}
                <div className="min-w-0">
                  <CardTitle className="flex items-center gap-2 text-lg font-semibold">{title}</CardTitle>
                  {description ? <CardDescription>{description}</CardDescription> : null}
                </div>
              </div>
              <ChevronDown className="w-5 h-5 shrink-0 text-muted-foreground transition-transform duration-200 [[data-state=open]_&]:rotate-180" />
            </CollapsibleTrigger>
            {headerAction ? <div className="shrink-0">{headerAction}</div> : null}
          </div>
        </CardHeader>
        <CollapsibleContent>
          <CardContent className="pt-0">{children}</CardContent>
        </CollapsibleContent>
      </Card>
    </Collapsible>
  )
}
